<template>
  <!--begin::Portlet-->
  <div class="kt-portlet">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <span class="kt-portlet__head-icon">
          <i class="fa fa-upload" />
        </span>
        <h3 class="kt-portlet__head-title">
          Uploader Info
        </h3>
      </div>
    </div>
    <div class="kt-portlet__body">
      <label for="expire_on">Modify Expiry Date</label>

      <div class="input-group kt-input-group">
        <div class="input-group kt-input-group">
          <datetime id="expire_on" v-model="expire_on"
                    type="date"
                    input-class="form-control kt-input"
                    format="yyyy-MM-dd" />
        </div>
      </div>

      <div v-if="uploader_profiles && uploader_profiles.length" class="form-group mt-3">
        <label for="uploader_profile">Uploader Profile <small>Used to create items on approval.</small></label>
        <select id="uploader_profile" v-model="selected_uploader_profile" class="form-control">
          <option :value="null" />
          <option v-for="uploader_profile in uploader_profiles" :key="uploader_profile.id" :value="uploader_profile.id">
            {{ uploader_profile.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="kt-portlet__foot">
      <button class="btn btn-ss-standout" @click="updateUser()">
        <i class="fa fa-save" />&nbsp;Save Changes
      </button>
    </div>
  </div>
  <!--end::Portlet-->
</template>
<script>
export default {
  data: () => ({
    user: window.user,
    expire_on: null,
    uploader_profiles: [],
    selected_uploader_profile: null,
  }),
  mounted() {
    if (this.user.expire_at) {
      this.expire_on = this.formatDate(this.user.expire_at);
    }
    this.getUploaderProfiles();
    this.selected_uploader_profile = this.user.uploader_profile_id;
  },
  methods: {
    getUploaderProfiles() {
      if (!this.permissionsCanAccessFeature('uploader_profiles')) {
        return;
      }
      axios.get(`/api/v1/uploader-profiles`).then((response) => {
        this.uploader_profiles = response.data.data;
      }).catch(() => {
        toastr.error("Could not retrieve uploader profiles");
      });
    },
    updateUser() {
      const form_data = {
        expire_on: this.expire_on,
        user_id: this.user.uuid,
        uploader_profile_id: this.selected_uploader_profile,
      };

      axios
        .put(`/api/v1/user/${this.user.uuid}`, form_data)
        .then((response) => {
          // Update user data after save
          this.user = response.data;
          toastr.success("Information updated.");
        })
        .catch((error) => {
          window.handleAxiosError(error);
        });
    },
  },
};
</script>
